import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=ca91e4d2&"
import script from "./FaqView.vue?vue&type=script&lang=js&"
export * from "./FaqView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports